import React from 'react';

export function V2TypingIndicator() {
  return (
    <div
      className="mr-auto rounded-xl p-3 bg-muted flex items-center gap-1.5"
      role="status"
      aria-label="AI is typing"
    >
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          className="size-2 rounded-full bg-muted-foreground animate-pulse-dot"
          style={{ animationDelay: `${i * 0.2}s` }}
        />
      ))}
    </div>
  );
}
